<template>
    <span></span>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import handleAction from '@mixins/HandleAction';

export default {
    name: 'TriggerElement',

    props: ['element', 'interaction'],

    mixins: [handleAction],

    computed: {
        ...mapGetters(['currentTime'])
    },

    data() {
        return {
            fired: false
        };
    },

    watch: {
        currentTime(newVal) {
            // Trigger element works just as a button click but it happens at a set time
            if (!this.fired && newVal > this.interaction.timeIn) {
                this.fired = true;
                this.handleClick();
            }

            // This resets the fired if the video goes back to before the time in
            if (this.fired && newVal < this.interaction.timeIn) {
                this.fired = false;
            }
        }
    }
};
</script>
